// IMPORTS
	import wixWindow from 'wix-window';
	import wixData from 'wix-data';

// FUNCTIONS
	$w.onReady(function () {
		// console.log("lightbox $w.onReady()");
		// let itemData = wixWindow.lightbox.getContext()
		// console.log({
		// 	func: "lightbox $w.onReady()",
		// 	itemData: itemData
		// });
		// $w("#productDataset").setFilter(wixData.filter().eq("_id", itemData._id))
		// $w("#price").text = "₪ " + itemData.Price
	});